import React from "react";
import "./HowMint.css";
import mint1 from "../Assets/mint1.png";
import mint2 from "../Assets/mint2.png";
import mint3 from "../Assets/mint3.png";
import right_a from "../Assets/right_angle.png"
import left_a from "../Assets/left_angle.png"
import banner from "../Assets/banner.jpg"
import mintted_bg from "../Assets/mint_bg_b.png"
export default function HowMint() {

  return (
    <div className="howtomint_page" id="HowToMint">
      <div className="container position-relative ">
        <h1 className="how_mint_head">How to mint </h1>
        
        {/* Banner Section */}
        <div className="row justify-content-center mb-5">
          <div className="col-md-8 text-center">
            <img src={banner} className="banner_mint" alt="Falco P Banner" />
          </div>
        </div>

        {/* Steps Section */}
        <div className="row mt-5">
          <div className="col-md-4 z_upper_full position-relative">
          <img src={left_a} className="left_angle d-none d-lg-block" alt="" />
            <div className="box_mint">
              <div className="mint_head_box d-flex justify-content-between  align-items-center">
                <h3 className="robo_font mb-0">Connect Wallet</h3>
                <img src={mint1} alt="" />
              </div>

              <p className="mint_para robo_font">
                Connect your digital wallet to access the Falco P marketplace. 
                Secure, fast, and easy integration with all major wallet providers.
              </p>
            </div>
          </div>
          <div className="col-md-4 z_upper_full mt-3 mt-md-0">
            <div className="box_mint">
              <div className="mint_head_box d-flex justify-content-between  align-items-center">
                <h3 className="robo_font mb-0">Browse Collection</h3>
                <img src={mint2} alt="" />
              </div>

              <p className="mint_para robo_font">
                Explore our exclusive Falco P sneaker collection. 
                Each NFT represents a unique piece of athletic innovation.
              </p>
            </div>
          </div>
          <div className="col-md-4 z_upper_full mt-3 mt-md-0 position-relative ">
          <img src={right_a} className="right_angle d-none d-lg-block" alt="" />
            <div className="box_mint">
              <div className="mint_head_box d-flex justify-content-between  align-items-center">
                <h3 className="robo_font mb-0">Mint NFT</h3>
                <img src={mint3} alt="" />
              </div>

              <p className="mint_para robo_font">
                Complete your purchase and mint your exclusive Falco P NFT. 
                Own a piece of the future of athletic fashion.
              </p>
            </div>
          </div>
        </div>

      </div>
        <img src={mintted_bg} className="minnted_bg d-none d-lg-block" alt="" />
    </div>
  );
}
